var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.4,
    viewBox: "0 0 18 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.247A4.035 4.035 0 0 1 4.982 7.5l-2.95-2.28A9.374 9.374 0 0 0 1 6.786a.91.91 0 0 0 0 .821A9.021 9.021 0 0 0 9 12.6a8.736 8.736 0 0 0 2.191-.294l-1.458-1.133a4.054 4.054 0 0 1-.733.074zm8.826 1.634-3.109-2.4A9.316 9.316 0 0 0 17 7.607a.91.91 0 0 0 0-.821A9.021 9.021 0 0 0 9 1.8a8.667 8.667 0 0 0-4.143 1.06L1.28.092a.45.45 0 0 0-.632.079L.1.881a.45.45 0 0 0 .079.631L16.723 14.3a.45.45 0 0 0 .632-.079l.552-.711a.45.45 0 0 0-.079-.629zM12.66 8.887l-1.105-.854A2.665 2.665 0 0 0 8.29 4.6a1.34 1.34 0 0 1 .262.793 1.312 1.312 0 0 1-.043.281l-2.07-1.6A4 4 0 0 1 9 3.147a4.048 4.048 0 0 1 4.05 4.05 3.954 3.954 0 0 1-.391 1.691z",
    transform: "translate(-.001 .003)",
    style: {
      fill: "#008da9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.2188576727ebd0b88792cc3e32b219a9.svg";
export { ForwardRef as ReactComponent };